import { useLayoutEffect, useRef } from 'react';

// Measure real bar heights so font size, ticker visibility and device safe areas
// cannot leave content hidden under the fixed navigation.
export const usePinnedNavigation = (isFullScreen) => {
  const shellRef = useRef(null);
  const headerRef = useRef(null);
  const footerRef = useRef(null);

  useLayoutEffect(() => {
    const shell = shellRef.current;
    if (!shell) return undefined;
    const measure = () => {
      const top = isFullScreen ? 0 : Math.ceil(headerRef.current?.getBoundingClientRect().height || 0);
      const bottom = isFullScreen ? 0 : Math.ceil(footerRef.current?.getBoundingClientRect().height || 0);
      shell.style.setProperty('--ps-shell-top', `${top}px`);
      shell.style.setProperty('--ps-shell-bottom', `${bottom}px`);
    };
    measure();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    if (headerRef.current) observer?.observe(headerRef.current);
    if (footerRef.current) observer?.observe(footerRef.current);
    window.addEventListener('resize', measure);
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [isFullScreen]);

  return { shellRef, headerRef, footerRef };
};